import React from "react";
import "./Title.scss";
const Title = ({className, children}) => <h2 className={"title " + className}>{children}</h2>;

export default Title;